import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Import testing utilities for production API debugging
import './utils/testProductionAPI';

// Enhanced service worker registration for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('[Main] SW registered successfully:', registration);

        // Check for updates immediately on load
        registration.update();

        // Check for updates every 60 seconds
        setInterval(() => {
          registration.update();
        }, 60000);

        // Check for updates on focus and visibility change
        window.addEventListener('focus', () => {
          registration.update();
        });

        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            registration.update();
          }
        });

        // Handle updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            console.log('[Main] New service worker found');
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  console.log('[Main] New content available');
                } else {
                  console.log('[Main] Content cached for offline use');
                }
              }
            });
          }
        });
      })
      .catch((error) => {
        console.error('[Main] SW registration failed:', error);
      });
  });
}

createRoot(document.getElementById("root")!).render(<App />);
